import { useSelector } from "react-redux"
import { Navigate, Outlet } from "react-router"

// export default function ProtectedRoute() {
// const is_verified=  localStorage.getItem("token")    
//     return (
//         is_verified ? <Outlet/>:<Navigate to="/authentication/sign-in"/> 
//     )
//   }
  
export default function ProtectedRoute() {
    const token = localStorage.getItem("token");

    // Ensure token is not null, undefined, or empty
    const isVerified = token && token !== "null" && token !== "undefined" && token.trim() !== "";

    return isVerified ? <Outlet /> : <Navigate to="/authentication/sign-in" replace />;
}
